<!-- 读片会 -->
<template>
  <div>
    <!-- 头部 -->
    <div>
      <van-nav-bar title="读片会" left-text="" @click-left="onClickLeft" @click-right="onClickRight" left-arrow>
        <template #right>
          <van-icon name="search" size="18" />
        </template>
      </van-nav-bar>
    </div>
    <!-- 筛选框 -->
    <div class="nav">
      <van-tabs @change="onChange" v-model="searchModel.courseStatus">
  <van-tab title="即将开课"></van-tab>
  <van-tab title="往期回顾"></van-tab>
</van-tabs>
    </div>
      <!-- 数据列表 -->
      <div class="img_detail" id='la'>
           <listContent :listData="dataList"></listContent>
             <div v-if="dataList.length == 0" class="local">
        <div class="noData">暂无数据，请联系管理员上传相应资料</div>
      </div>
      </div>
  </div>
</template>

<script>
import listContent from '../../../../components/basics/list-content.vue'
export default {
  components: { listContent },
  data () {
    return {
      // 初始化搜索数据
      searchModel: {
        current: 1,
        dataName: '',
        size: 8,
        sortType: 0, //, 0:按时间升序，1：按时间倒序(默认)，2：按浏览量大到小
        courseStatus: 0, // 0，即将开课，1.往期回顾，不传默认全部
        moduleId: ''
      },
      pageCount: 1,
      isPush: true, // 用于锁定，防止连续拉动刷新调用接口

      // 下方数据内容
      dataList: []
    };
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created () {
    this.searchModel.moduleId = this.$route.query.moduleId
    this.searchModel.seriesId = this.$route.query.seriesId
    this.info()
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted () {
    this.listen();
  },
  methods: {
    // 初始化
    info () {
      this.searchModel.current = 1;
      const Data = this.searchModel;
      this.$axios
        .post('/edu/home/page/mobile/search', { data: Data })
        .then((res) => {
          this.dataList = res.data.list;
          this.pageCount = res.data.pageCount;
          this.searchModel.current = res.data.current;
        });
    },
    onChange () {
      if (this.searchModel.courseStatus === 0) {
        this.searchModel.sortType = 0
      } else {
        this.searchModel.sortType = 1
      }
      this.isPush = true;
      this.info()
    },
    // 监听滚动条
    listen () {
      const scrollElement = document.querySelector('#la');
      scrollElement.addEventListener(
        'scroll',
        () => {
          const bottom =
            scrollElement.scrollHeight -
            scrollElement.scrollTop -
            scrollElement.clientHeight;
          if (bottom < 50 && this.isPush) {
            this.isPush = false;
            this.onload();
          }
        },
        false
      );
    },
    // 下拉加载
    onload () {
      if (this.searchModel.current < this.pageCount) {
        const scrollElement = document.querySelector('#la');
        scrollElement.scrollTop = 0;
        this.searchModel.current = this.searchModel.current + 1;
        const Data = this.searchModel;
        this.$axios
          .post('/edu/home/page/mobile/search', { data: Data })
          .then((res) => {
            this.dataList = this.dataList.concat(res.data.list);
            this.pageCount = res.data.pageCount;
            this.searchModel.current = res.data.current;
            this.isPush = true;
          });
      }
    },

    onClickLeft () {
      history.back()
    },
    onClickRight () {
      this.$router.push({
        path: '/search/search_list',
        query: { moduleId: this.searchModel.moduleId, seriesId: this.searchModel.seriesId }
      })
    }
  }
};
</script>
<style lang='scss' scoped>
/* @import url(); 引入css类 */
.local {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
}
.noData {
  width: 50vw;
  font-size: 20px;
  color: rgb(204, 199, 194);
  margin-top: 30vh;
}
.nav{
  margin-top: 50px;
}
.img_detail{
    overflow-y: auto;
    max-height: calc(100vh - 100px);
    padding-bottom: 10px;
}
</style>
